import React from "react";
import ProjectShowcase from "./component/project-showcase";
import CapeIMG from "./img/Cape/Cape.png";
import demoVideo from "./img/Cape/screen-capture (8).mp4";

function Cape() {
  const processSteps = [
    {
      text: (
        <>
          This project was split into 5 different sections following the{" "}
          <span style={{ fontWeight: "bold" }}>design thinking methodology</span>.
        </>
      ),
    },
    {
      text: (
        <>
          First, came the <span style={{ fontWeight: "bold" }}>empathise phase</span>. During which I conducted various{" "}
          <span style={{ fontWeight: "bold" }}>interviews</span> with the key{" "}
          <span style={{ fontWeight: "bold" }}>stakeholders</span> of this project to get an understanding of the{" "}
          <span style={{ fontWeight: "bold" }}>problem</span> that I was tasked to solve for the small business owners.
          These interviews proved to be very helpful in <span style={{ fontWeight: "bold" }}>scoping the problem</span>{" "}
          and helped me create a <span style={{ fontWeight: "bold" }}>persona</span> that could be used to test my
          theories, which is that these business owners really struggle with{" "}
          <span style={{ fontWeight: "bold" }}>ad creation</span>, and could really use some help.
        </>
      ),
    },
    {
      text: (
        <>
          With the conclusion of the empathize phase, the <span style={{ fontWeight: "bold" }}>Define phase</span>{" "}
          started. The results of the last phase helped me{" "}
          <span style={{ fontWeight: "bold" }}>scope out the project</span> in steps by creating a{" "}
          <span style={{ fontWeight: "bold" }}>stakeholder analysis</span> and a{" "}
          <span style={{ fontWeight: "bold" }}>competitors analysis</span> to see what kind of A.I tools are already on
          the market. The Define phase was then finalized with the creation of a{" "}
          <span style={{ fontWeight: "bold" }}>user flow</span>, which mapped the complete user story into view. This
          would be instrumental for coming up with a solution.
        </>
      ),
    },
    {
      text: (
        <>
          Then the <span style={{ fontWeight: "bold" }}>Ideate phase</span> started. During this phase I took all of the
          results from the previous phases and combined them with new results from{" "}
          <span style={{ fontWeight: "bold" }}>brainstorming sessions</span> and{" "}
          <span style={{ fontWeight: "bold" }}>sketches</span> that would lead me to come up with the first possible
          solutions to this project. This first draft would help shape the{" "}
          <span style={{ fontWeight: "bold" }}>design</span> and <span style={{ fontWeight: "bold" }}>prototype</span>{" "}
          phase.
        </>
      ),
    },
    {
      text: (
        <>
          During this phase, I took the sketches and slowly went through the steps it takes to create a{" "}
          <span style={{ fontWeight: "bold" }}>prototype</span> of the A.I tool. This meant creating{" "}
          <span style={{ fontWeight: "bold" }}>wireframes</span>, ensuring the{" "}
          <span style={{ fontWeight: "bold" }}>product owner</span> agrees with each step and then continuing with a
          higher definition version of the prototype.
        </>
      ),
    },
    {
      text: (
        <>
          I could use this design to <span style={{ fontWeight: "bold" }}>test with users</span> to see if my ideas
          would work in reality, and correct any mistakes I made in the design. The most important aspects during this
          phase is the <span style={{ fontWeight: "bold" }}>UX and UI design</span>, where I would make sure that the
          design is <span style={{ fontWeight: "bold" }}>usable</span> for the users, as well as{" "}
          <span style={{ fontWeight: "bold" }}>aesthetically pleasing</span> for the eye.
        </>
      ),
    },
    {
      text: (
        <>
          The design went through many different <span style={{ fontWeight: "bold" }}>iterations</span>, each time with
          a slightly improved feature or an even easier way to do something. All was confirmed during{" "}
          <span style={{ fontWeight: "bold" }}>testing with users</span> to ensure that the tool stays{" "}
          <span style={{ fontWeight: "bold" }}>user centered</span>.
        </>
      ),
    },
    {
      text: (
        <>
          After the design was finalized, work on creating a coded <span style={{ fontWeight: "bold" }}>MVP</span>. I
          coded it using <span style={{ fontWeight: "bold" }}>ReactJS, Typescript and MUI</span> and intergrating the
          API'S provided by the backend developer After the development of this tool I reached out to{" "}
          <span style={{ fontWeight: "bold" }}>small business owners</span> to test my tool. These tests resulted in an{" "}
          <span style={{ fontWeight: "bold" }}>overwhelmingly positive result</span> and many ideas to further refine
          the concept and the tool.
        </>
      ),
    },
    {
      text: (
        <>
          During the development, the <span style={{ fontWeight: "bold" }}>A.I</span> used in the tool was also
          constantly being tweaked to ensure the most <span style={{ fontWeight: "bold" }}>realistic</span> possible{" "}
          <span style={{ fontWeight: "bold" }}>ad generation</span>.
        </>
      ),
    },
    {
      text: (
        <>
          The end result was a fully developed and tested <span style={{ fontWeight: "bold" }}>MVP</span> that was{" "}
          <span style={{ fontWeight: "bold" }}>market ready</span>. Users praised the{" "}
          <span style={{ fontWeight: "bold" }}>design</span> and{" "}
          <span style={{ fontWeight: "bold" }}>functionality</span> to “
          <span style={{ fontWeight: "bold" }}>Really change the way I work</span>” and “
          <span style={{ fontWeight: "bold" }}>This would really raise my business potential</span>”.
        </>
      ),
    },
  ];

  return (
    <div>
      <ProjectShowcase
        name="ProdShot: Simplifying Ad Creation with AI"
        img={CapeIMG}
        description="ProdShot is an AI-powered ad creation tool designed to support small business owners with limited marketing experience in generating effective, platform-ready advertisements. During my graduation internship at Cape, I led the design and front-end development of this tool, focusing on simplifying the ad creation process through a seamless, user-friendly interface."
        tools="Figma,Reactjs,Typescript,MUI,"
        role="UX/UI designer, Frontend Developer"
        processSteps={processSteps}
        link="https://www.figma.com/design/YaIySm1jI8NhtUZ9U127AN/AI-ad-generator?node-id=96-566&t=BY8Iwondt514sF9U-1"
        linkName="Figma"
      />

      {/* Video section */}
      <div
        style={{
          marginTop: "2rem",
          marginBottom: "2rem",
          marginLeft: "2rem",
          marginRight: "2rem",
          textAlign: "center",
        }}
      >
        <video width="50%" controls>
          <source src={demoVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export default Cape;
